import { render } from "./containerd-registry.vue?vue&type=template&id=15c71f8d&scoped=true"
import script from "./containerd-registry.vue?vue&type=script&lang=js"
export * from "./containerd-registry.vue?vue&type=script&lang=js"

import "./containerd-registry.vue?vue&type=style&index=0&id=15c71f8d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c71f8d"]])

export default __exports__